module.exports = __webpack_public_path__ + "img/news-m.d8647e59.png";